<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Placówki</span>
        <h3 class="page-title">
          <template v-if="isEdit">Edycja placówki</template>
          <template v-else>Dodawanie placówki</template>
        </h3>
      </d-col>
      <d-col
        col
        sm="6"
        class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button
          theme="secondary"
          @click.prevent="$router.push('/placowki')"
          class="mr-1">
          <i class="material-icons">arrow_back</i>
          Wróć do listy
        </d-button>
        <d-button
          theme="success"
          @click.prevent="validateForm">
          Zapisz zmiany
        </d-button>
      </d-col>
    </d-row>
    <!-- Form -->
    <d-form>
      <d-card class="mb-5">
        <d-tabs card>
          <!-- Dane ogólne -->
          <d-tab title="Dane ogólne" active>
            <h4 class="mb-3 pb-3 border-bottom">
              {{ isEdit ? 'Nazwa placówki' : 'Podaj nazwę placówki'}}
            </h4>
            <validation-observer ref="institutions-form" tag="form">
              <div class="form-group">
                <label for="name">
                  Nazwa:
                </label>
                <validation-provider
                  rules="required"
                  name="name"
                  v-slot="{ errors }">
                  <d-input
                    :state="errors.length ? 'invalid' : null"
                    v-model="data.name" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
            </validation-observer>
            <div v-if="!allDataLoaded" class="pb-3 pt-3 text-center">
              Trwa ładowanie danych&hellip;
            </div>
            <d-alert
              v-if="loadError"
              show
              theme="warning">
              Wczytywanie danych nie powiodło się. <a href="javascript:window.location.reload();" class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
            </d-alert>
          </d-tab>
          <d-tab title="Lista pracowników" v-if="isEdit">
            <d-row no-gutters class="page-header py-4 mb-2">
              <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
                <h4>Lista pracowników: <p class="mt-1 mb-0" style="font-weight: 100; color: #17c671">{{data.name}}</p></h4>
              </d-col>
            </d-row>
            <table class="table mt-0 mb-0 full-width">
              <thead class="bg-light">
              <tr>
                <th scope="col" class="border-0">Imię i nazwisko</th>
                <th scope="col" class="border-0">E-mail</th>
                <th scope="col" class="border-0">Wymiar pracy</th>
                <th scope="col" class="border-0">Przełożony</th>
                <th scope="col" class="border-0">Edytuj</th>
              </tr>
              </thead>
              <tbody v-if="loaded">
              <tr
                v-for="(users, indexService) in institutionsUsers[0]"
                :key="indexService">
                <td class="align-middle" v-for="(user, indexUser) in usersArr" :key="'user-name-' + indexUser" v-if="user.id === users.id">
                  {{user.name}} {{user.last_name}}
                </td>
                <td class="align-middle" v-for="(user, indexUser) in usersArr" :key="'user-email-' + indexUser" v-if="user.id === users.id">
                  {{user.email}}
                </td>
                <td class="align-middle" v-for="(user, indexUser) in usersArr" :key="'user-type-' + indexUser" v-if="user.id === users.id">
                  {{user.employment_typ !== 'E_PART_TIME' ? 'Pełen etat' : 'Pół etatu'}}
                </td>
                <td class="align-middle" v-for="(user, indexUser) in usersArr" :key="'user-parent-' + indexUser" v-if="user.id === users.id">
                  <div style="opacity: 0.7" v-for="(boss, index) in bosses" :key="'boss-' + index">
                    {{ user.parent_id === boss.id ? (boss.name + ' ' + boss.last_name) : '' }}
                  </div>
                </td>
                <td
                  class="align-middle">
                  <d-button
                    style="width: 100px;"
                    theme="primary"
                    @click.prevent="$router.push('/uzytkownicy/edycja/' + users.id)"
                    class="mr-2"
                    title="Edytuj">
                    <i class="material-icons">edit</i>
                  </d-button>
                </td>
              </tr>
              <tr>
                <td
                  v-if="(institutionsUsers[0] ? (institutionsUsers[0].length === 0) : '') || !institutionsUsers.length"
                  colspan="5"
                  class="text-center">
                  Brak pracowników do wyświetlenia&hellip;
                </td>
              </tr>
              </tbody>
            </table>
            <div v-if="!institutions" class="pb-3 pt-3 text-center">
              Trwa ładowanie danych&hellip;
            </div>
            <d-alert
              v-if="loadError"
              show
              theme="warning">
              Wczytywanie danych nie powiodło się. <a href="javascript:window.location.reload();" class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
            </d-alert>
          </d-tab>
          <d-tab title="Usługi" v-if="isEdit">
            <d-row no-gutters class="page-header py-4 mb-2">
              <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
                <h4>Lista usług: <p class="mt-1 mb-0" style="font-weight: 100; color: #17c671">{{data.name}}</p></h4>
              </d-col>
            </d-row>
            <table class="table mt-0 mb-0 full-width">
              <thead class="bg-light">
              <tr>
                <th scope="col" class="border-0">ID</th>
                <th scope="col" class="border-0">Nazwa</th>
                <th scope="col" class="border-0">Kategoria</th>
                <th scope="col" class="border-0">Edytuj</th>
              </tr>
              </thead>
              <tbody v-if="loaded">
              <tr
                v-for="(service, indexService) in servicesInInstitutions"
                :key="indexService">
                <td class="align-middle">
                  {{service.id}}
                </td>
                <td class="align-middle">
                  {{service.name}}
                </td>
                <td class="align-middle">
                  {{service.category_name}}
                </td>
                <td
                  class="align-middle">
                  <d-button
                    style="width: 100px;"
                    theme="primary"
                    @click.prevent="$router.push('/usługi/edycja/' + service.id)"
                    class="mr-2"
                    title="Edytuj">
                    <i class="material-icons">edit</i>
                  </d-button>
                </td>
              </tr>
              <tr>
                <td
                  v-if="servicesInInstitutions ? (servicesInInstitutions.length === 0) : ''"
                  colspan="4"
                  class="text-center">
                  Brak usług do wyświetlenia&hellip;
                </td>
              </tr>
              </tbody>
            </table>
            <div v-if="!institutions" class="pb-3 pt-3 text-center">
              Trwa ładowanie danych&hellip;
            </div>
            <d-alert
              v-if="loadError"
              show
              theme="warning">
              Wczytywanie danych nie powiodło się. <a href="javascript:window.location.reload();" class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
            </d-alert>
          </d-tab>
        </d-tabs>
      </d-card>
    </d-form>
  </d-container>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';
import ListUtils from './../../utils/ListUtils.js';

export default {
  name: 'institution-form',
  computed: {
    allDataLoaded () {
      return this.loaded && this.loadedInstitutions;
    },
    isEdit () {
      return !!this.$route.params.id;
    }
  },
  data() {
    return {
      data: {
        id: '',
        name: '',
      },
      loaded: false,
      loadError: false,
      institutions: [],
      institutionsUsers: [],
      services: [],
      servicesInInstitutions: [],
      bosses: [],
      usersArr: [],
      loadedInstitutions: false
    };
  },
  mounted () {
    if (this.isEdit) {
      this.loadItemData();
      this.loadServicesData();
    } else {
      this.loaded = true;
    }

    this.loadAdditionalData();
  },
  watch: {
    'institutions': function (value) {
      if (value.length) {
        this.dataInstitutionsUsers()
      }
    },
    'services': function (value) {
      if (value.length) {
        this.dataServicesInInstitutions();
        this.loadUsersData();
        this.getBossList();
      }
    }
  },
  methods: {
    dataServicesInInstitutions () {
      const services = this.services;
      const checkId = this.data.id;
      let institutionsArr = [];
      let institutions = [];
      for (let i = 0; i < services.length; i++) {
        institutionsArr = services[i].institutions;
        for (let j = 0; j < institutionsArr.length; j++) {
          if (checkId === institutionsArr[j].id) {
            institutions[i] = services[i];
          }
        }
      }
      this.servicesInInstitutions = institutions.filter(n => n);
    },
    dataInstitutionsUsers () {
      const institutions = this.institutions;
      const checkId = this.data.id;
      let users = [];
      for (let i = 0; i < institutions.length; i++) {
        if (checkId === institutions[i].id) {
          users[i] = institutions[i].users;
        }
      }
      this.institutionsUsers = users.filter(n => n);
    },
    getBossList () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/users/bosses',
        outputKey: 'bosses',
      });
    },
    loadServicesData () {
      ListUtils.loadItemsData(this, {
        endpoint: '/services/items',
        listField: 'services',
        params: {
          pagination: false
        },
      });
    },
    loadUsersData () {
      ListUtils.loadItemsData(this, {
        endpoint: '/users/items',
        listField: 'usersArr',
        params: {
          pagination: false
        },
      });
    },
    loadItemData () {
      FormUtils.loadItemData(this, {
        endpointBase: '/institutions/item/',
        instanceFields: ['id', 'name'],
        loadedKey: 'loaded'
      });
    },
    loadAdditionalData () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/institutions/items',
        params: {
          pagination: false
        },
        outputKey: 'institutions',
        loadedKey: 'loadedInstitutions',
        errorKey: 'loadError',
      });
    },
    validateForm () {
      FormUtils.validate(this.$refs['institutions-form'], this.submitForm);
    },
    submitForm () {
      let formDataToSend = this.prepareFormDataToSend();
      let endpointUrl = this.isEdit ? '/institutions/update/' + this.id : '/institutions/store';

      FormUtils.submit(this, {
        endpoint: endpointUrl,
        formData: formDataToSend,
        successTitle: 'Zapisano placówkę',
        successText: 'Wybrana placówka została zapisana',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Modyfikacje placówki nie powiodły się. Spróbuj ponownie.',
        successAction: () => {
          this.$router.push('/placowki')
        }
      });
    },
    prepareFormDataToSend () {
      return {
        name: this.data.name,
      };
    }
  }
};
</script>
